export default () => ({
  handler: 'relativeUrl',
  data: () => '/',
});
